<template>
  <div id="app">
    <UIheader></UIheader>
    <router-view style="margin-top:125px;"/>
    <UIBottom></UIBottom>
  </div>
</template>

<script>
import UIheader from '@/components/components/header';
import UIBottom from '@/components/components/bottom'
export default {
  components:{
    UIheader,UIBottom
  },
  mounted(){
  },
  methods:{

  }
}
</script>

<style>
#app {
  font-size: 14px;
  /*line-height: 1.8em;*/
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  margin: 0;
  background: #F6F6F6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #555;
  word-wrap: break-word;
  text-align: justify;
}
.page-title {
  font-size: 24px;
  margin-bottom:35px;
  color:#b69859;
}
.page-title > h3 {
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue